import script from "./NavbarTop.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarTop.vue?vue&type=script&setup=true&lang=js"

import "./NavbarTop.vue?vue&type=style&index=0&id=4c2c4f46&lang=scss&scoped=true"

import exportComponent from "/Users/sam/WebDev/Projects/debtnote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2c4f46"]])

export default __exports__